module.exports = __webpack_public_path__ + "static/img/hatchback-green.3ea6741.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/hatchback-green.svg
// module id = uh42
// module chunks = 82